export default {
  biostimulationTestsList: [],
  biostimulationTestSelected: null,
  biostimulationNegativeControl: null,
};
